import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React, { useContext } from 'react';
import classnames from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import s from './Separator.scss';
export var Breakpoint;
(function(Breakpoint) {
    Breakpoint[Breakpoint["Both"] = 0] = "Both";
    Breakpoint[Breakpoint["Desktop"] = 1] = "Desktop";
    Breakpoint[Breakpoint["Mobile"] = 2] = "Mobile";
})(Breakpoint || (Breakpoint = {}));
const Separator = (_param)=>{
    var { className , forBreakpoint =Breakpoint.Both  } = _param, rest = _object_without_properties(_param, [
        "className",
        "forBreakpoint"
    ]);
    const isMobile = useContext(MobileContext);
    return /*#__PURE__*/ React.createElement("hr", _extends({
        className: classnames(className, s['separator'], forBreakpoint === Breakpoint.Desktop && isMobile && s['hidden'], forBreakpoint === Breakpoint.Mobile && !isMobile && s['hidden'])
    }, rest));
};
Separator.displayName = 'Separator';
export default Separator;
